import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosAdmin from "../../../../../api/apiAdmin";
import { successToast, errorToast } from "../../../toastAlerts/ToastAlerts";
import ContinueComponent from "../../../toastAlerts/ContinueComponent";
import PriceAuditModal from "../PriceAudit/PriceAuditModal";
import IncidentModal from "../Incident/IncidentModal";
import IncidentBadge from "../Incident/IncidentBadge";
import PriceInfoButton from "../../../../../components/PriceExplain/PriceInfoButton";
import { priceNeedsExplaining } from "../../../../../components/PriceExplain/billedWeight";

//icons
import {
    BsBoxArrowInRight,
    BsTrash,
    BsFillPersonFill,
    BsFillEnvelopeFill,
    BsTelephoneFill,
    BsFillHandbagFill,
    BsFillBuildingFill,
    BsArrowReturnLeft,
    BsCalendar,
} from "react-icons/bs";
import { BiPackage, BiSave } from "react-icons/bi";
import {
    FaBarcode,
    FaMoneyBillAlt,
    FaPlaneDeparture,
    FaScroll,
    FaTruckMoving,
} from "react-icons/fa";
import { GiWeight } from "react-icons/gi";
import { useTranslation } from "react-i18next";
import { apiError } from "../../../../../api/apiError";

const SentItem = ({
    data,
    handleDeletePackage,
    setCheckedAll,
    handleSelectedPackages,
    handleDeleteSelectedPackages,
    setDifResponses,
    handleSendBack,
    handleGiveUserToParcel,
    handleUndeclared,
}) => {
    const { t } = useTranslation();
    //package check
    const [check, setCheck] = useState(false);
    //show contnue
    const [showContinue, setShowContinue] = useState(false);
    const [showPriceAudit, setShowPriceAudit] = useState(false);
    const [showIncident, setShowIncident] = useState(false);
    //updated pack values
    const [updatedData, setUpdatedData] = useState({});

    const handleUpdateData = (key, value) => {
        setUpdatedData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    //handle checking
    const handleCheck = (e) => {
        setCheck(e.target.checked);
        if (e.target.checked) {
            handleSelectedPackages(data.id);
        } else {
            handleDeleteSelectedPackages(data.id);
        }
    };

    const handleRemoveRepack = (id) => {
        axiosAdmin
            .put(`packs/${id}`, { repack: 0 })
            .then((res) => {
                successToast(t("success"));
            })
            .catch((err) => {
                errorToast(t("error"));
            });
    };

    //check all controller
    useEffect(() => {
        setCheck(setCheckedAll);
        if (setCheckedAll) {
            handleSelectedPackages(data.id);
        } else {
            handleDeleteSelectedPackages(data.id);
        }
    }, [setCheckedAll]);

    //const handle send package
    const handleSend = async () => {
        try {
            const res = await axiosAdmin.put(`/packs/${data.id}`, {
                status: "2.5",
            });
            if (res) {
                successToast(t("admin_packages_received"));
                setDifResponses(res);
            }
        } catch (err) {
            errorToast(apiError(err, t("admin_error")));
        }
    };

    const handleNullifyFine = () => {
        axiosAdmin
            .post(`pack/nojarima/${data.id}`)
            .then((res) => {
                successToast(t("success"));
            })
            .catch((err) => {
                errorToast(t("error"));
            });
    };

    const handleBorderDeclaration = (status) => {
        axiosAdmin
            .put(`/borderDeclaration/${data.id}/${status}`)
            .then((res) => {
                successToast(t("success"));
                setDifResponses(res);
            })
            .catch((err) => {
                errorToast(t("error"));
            });
    };

    useEffect(() => {
        handleUpdateData("addon_secur", data.addon_secur);
    }, [data]);

    return (
        <div className={`p-4 rounded-lg relative dark:bg-slate-700 ${
            (data?.border_declar ?? 0) === 0 ? 'bg-gray-100' :
            (data?.border_declar ?? 0) === 1 ? 'bg-red-100' :
            (data?.border_declar ?? 0) === 2 ? 'bg-green-100' :
            (data?.border_declar ?? 0) === 3 ? 'bg-yellow-100' :
            'bg-white'
        }`}>
            <div className="absolute top-5 right-5">
                <input
                    onChange={(e) => {
                        handleCheck(e);
                    }}
                    checked={check}
                    type="checkbox"
                    className="w-4 h-4"
                />
            </div>
            <div
                className="w-full flex flex-wrap justify-between pb-2
            gap-y-2 border-b border-gray-200 mb-2"
            >
                <div className="w-[32%] md:w-[49%] sm:w-[100%] flex flex-col gap-y-1">
                    <div className="w-full">
                        <p className="text-[#989ba5] text-[12px]">
                            {t("admin_user_info")}
                        </p>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillPersonFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            {data.user !== undefined &&
                                data.user !== null &&
                                (data.user.company_id === undefined ||
                                data.user.company_id === null ? (
                                    <p className="text-slate-500 dark:text-gray-400 text-[12px] font-bold">
                                        {`${data.user.fname} ${data.user.lname}`}
                                    </p>
                                ) : (
                                    <p className="text-slate-500 dark:text-gray-400 text-[12px] font-bold">
                                        {`${data.user.cname} ${data.user.cname_eng}`}
                                    </p>
                                ))}
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaBarcode className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">{`id: ${
                                data.user !== undefined &&
                                data.user !== null &&
                                data.user.id
                            }`}</p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillEnvelopeFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {data.user !== undefined &&
                                    data.user !== null &&
                                    data.user.email}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400  rounded-lg p-2">
                                <BsTelephoneFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {data.user !== undefined &&
                                    data.user !== null &&
                                    data.user.phone}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaMoneyBillAlt className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] font-bold
                        ${
                            data.transport_price === data.transport_paid
                                ? "text-green-400"
                                : "text-red-400"
                        }`}
                            >
                                {t("admin_status")}:{" "}
                                {data.transport_price === data.transport_paid
                                    ? "paid"
                                    : "not paid"}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsCalendar className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_created_date")}: {data.created_at}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsCalendar className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_fine")}: {data.fine_price}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-[32%] md:w-[49%] sm:w-[100%] flex flex-col gap-y-1">
                    <div className="w-full">
                        <p className="text-[#989ba5] text-[12px]">
                            {t("admin_shipment_info")}
                        </p>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BiPackage className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_tracking_number")}: {data.tracking_number}
                            </p>
                            <IncidentBadge incident={data.incident} />
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaMoneyBillAlt className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_total_price")}: {data.transport_price.toFixed(2)}
                            </p>
                            {/* The same breakdown the customer sees, so support and
                                customer are never reading two different explanations. */}
                            {priceNeedsExplaining(data) && (
                               <PriceInfoButton
                                  fetcher={() =>
                                     axiosAdmin
                                        .get(`/packs/${data.id}/priceExplain`)
                                        .then(({ data: d }) => d)
                                  }
                               />
                            )}
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <GiWeight className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_total_weight")}: {data.total_weight.toFixed(2)} {t("admin_kg")}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaScroll className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] ${
                                    data.addon_transportation
                                        ? "text-green-500"
                                        : "text-red-500"
                                } `}
                            >
                                {data.addon_secur
                                    ? t("admin_insured")
                                    : t("admin_not_insured")}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillBuildingFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] text-slate-500 dark:text-gray-400 cursor-pointer font-bold`}
                            >
                                {t("admin_office")}:{" "}
                                {data.office !== null && data.office.name}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillPersonFill className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_trusted_person")}: {data.another_person}{" "}
                                {data.another_person_id}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-[32%] md:w-[49%] sm:w-[100%] flex flex-col gap-y-1">
                    <div className="w-full">
                        <p className="text-[#989ba5] text-[12px]">
                            {t("admin_shipment_info")}
                        </p>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaTruckMoving className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] ${
                                    data.addon_transp
                                        ? "text-green-500"
                                        : "text-red-500"
                                } `}
                            >
                                {t("admin_transportation")}: <br />{" "}
                                {data.addon_transp ? data.addon_transp : "X"}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaScroll className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            {data.invoice !== "" && data.invoice !== null ? (
                                <Link
                                    to={`${process.env.REACT_APP_API_URL}/storage/${data.invoice}`}
                                    target={"_blank"}
                                >
                                    <p
                                        className={`text-[14px] text-violet-500 underline cursor-pointer`}
                                    >
                                        invoice
                                    </p>
                                </Link>
                            ) : (
                                <p
                                    className={`text-[14px] text-red-500 underline cursor-pointer`}
                                >
                                    invoice
                                </p>
                            )}
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BsFillHandbagFill className="w-full h-full dark:text-gray-400 text-slate-500" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_bag")}: {data.bag}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <GiWeight className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p className="text-slate-500 dark:text-gray-400 text-[14px] font-bold">
                                {t("admin_volume_weight")}:{" "}
                                {data.volume_weight !== null &&
                                    data.volume_weight.toFixed(2)}{" "}
                                {t("admin_kg")}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <FaPlaneDeparture className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] text-slate-500 dark:text-gray-400 cursor-pointer font-bold`}
                            >
                                {t("admin_flight")}: {data.shipment_code}
                            </p>
                        </div>
                        <div className="flex items-center gap-1 my-1">
                            <div className="w-8 h-8 border border-slate-500 dark:border-gray-400 rounded-lg p-2">
                                <BiPackage className="w-full h-full text-slate-500 dark:text-gray-400" />
                            </div>
                            <p
                                className={`text-[14px] font-bold ${
                                    data.repack === 1
                                        ? "text-green-500"
                                        : "text-red-500"
                                }`}
                            >
                                {t("admin_repack_needed")}:{" "}
                                {data.repack === 1 ? t("admin_yes") : t("admin_no")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex gap-1 w-full justify-between flex-col sm:gap-y-2">
                <div className="flex flex-col gap-y-1">
                    <p className="text-[#989ba5] text-[12px]">{t("admin_comment")}:</p>
                    <p className="text-slate-500 dark:text-gray-400 text-[14px]">
                        {data.comment}
                    </p>
                </div>
                <div className="bg-white dark:bg-slate-800 w-full grid grid-cols-4 sm:grid-cols-1 gap-2">
                    <input
                        placeholder={t("admin_assign_user")}
                        onChange={(e) => {
                            handleUpdateData("userId", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <input
                        placeholder={t("admin_weight")}
                        onChange={(e) => {
                            handleUpdateData("weight", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <div className="flex gap-2 w-full items-center">
                        <input
                            placeholder={t("admin_length")}
                            onChange={(e) => {
                                handleUpdateData("dementionX", e.target.value);
                            }}
                            className="w-full h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                        />
                        <input
                            placeholder={t("admin_width")}
                            onChange={(e) => {
                                handleUpdateData("dementionY", e.target.value);
                            }}
                            className="w-full h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                        />
                        <input
                            placeholder={t("admin_height")}
                            onChange={(e) => {
                                handleUpdateData("dementionZ", e.target.value);
                            }}
                            className="w-full h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                        />
                    </div>
                    <input
                        placeholder={t("admin_transport_price")}
                        onChange={(e) => {
                            handleUpdateData("transport_price", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <input
                        placeholder={t("admin_flight_number")}
                        onChange={(e) => {
                            handleUpdateData("flightNumber", e.target.value);
                        }}
                        className="h-10 pl-1.5 focus:outline-none dark:text-white border border-slate-200 rounded-lg dark:bg-slate-800"
                    />
                    <div className="flex items-center gap-2">
                        <input
                            type="checkbox"
                            onChange={(e) => {
                                handleUpdateData(
                                    "addon_secur",
                                    e.target.checked ? 1 : 0
                                );
                            }}
                            checked={updatedData.addon_secur ? true : false}
                        />
                        <p>{t("admin_insurance")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleGiveUserToParcel(updatedData, data.id);
                        }}
                        className="rounded-lg bg-purple-400 flex items-center justify-center gap-2 px-4 h-10
md:w-full cursor-pointer text-sm "
                    >
                        <BiSave className="text-white font-bold" />
                        <p className="text-white font-bold">{t("admin_save")}</p>
                    </div>
                    {data.repack !== 0 && (
                        <div
                            onClick={() => {
                                handleRemoveRepack(data.id);
                            }}
                            className="rounded-lg bg-green-400 flex items-center justify-center gap-2 px-4 h-10
md:w-full cursor-pointer text-sm "
                        >
                            <p className="text-white font-bold">
                                {t("admin_remove_repack")}
                            </p>
                        </div>
                    )}
                </div>
                <div className="w-full grid grid-cols-4 sm:grid-cols-1 gap-2">
                    {data.packItems !== null && data.packItems.length !== 0 && (
                        <div
                            onClick={() => {
                                handleUndeclared(data.id);
                            }}
                            className="rounded-lg bg-purple-400 flex items-center justify-center gap-2 px-4 h-10 md:w-full cursor-pointer"
                        >
                            <p className="text-white font-bold">
                                {t("admin_delete_declaration")}
                            </p>
                        </div>
                    )}
                    <div
                        onClick={handleSend}
                        className="rounded-lg bg-yellow-400 flex items-center justify-center gap-2 px-4 h-10 w-full cursor-pointer"
                    >
                        <BsBoxArrowInRight className="text-white font-bold" />
                        <p className="text-white font-bold">{t("admin_receive")}</p>
                    </div>
                    <div
                        onClick={() => {
                            setShowContinue(true);
                        }}
                        className="w-full h-10 rounded-lg bg-red-400 flex items-center justify-center cursor-pointer"
                    >
                        <BsTrash className="text-white font-bold" />
                        <p className="text-white font-bold">{t("admin_delete")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleSendBack(data.id);
                        }}
                        className="h-10 w-full rounded-lg bg-green-400 flex items-center justify-center cursor-pointer px-2 text-white gap-2"
                    >
                        <BsArrowReturnLeft className="text-white font-bold" />
                        <p className="text-white font-bold">{t("admin_back")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleNullifyFine();
                        }}
                        className="w-full h-10 rounded-lg bg-blue-600 flex items-center justify-center cursor-pointer"
                    >
                        <p className="text-white font-bold">{t("admin_nullify_fine")}</p>
                    </div>
                    <div
                        onClick={() => setShowPriceAudit(true)}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer ${
                            data.price_locked ? "bg-red-500" : "bg-indigo-500"
                        }`}
                    >
                        <p className="text-white font-bold">
                            {data.price_locked ? "🔒 " : ""}
                            {t("admin_price_history") || "Price history & lock"}
                        </p>
                    </div>
                    <div
                        onClick={() => !data.incident && setShowIncident(true)}
                        title={data.incident ? data.incident.reason : "დაზიანდა / დაიკარგა"}
                        className={`h-10 rounded-lg flex items-center justify-center px-2 ${
                            data.incident ? "bg-slate-400 cursor-default" : "bg-red-600 cursor-pointer"
                        }`}
                    >
                        <p className="text-white font-bold">
                            {data.incident ? `${data.incident.type_label || ""} ✓` : "დაზიანდა / დაიკარგა"}
                        </p>
                    </div>
                </div>
                <div className={`w-full grid grid-cols-4 sm:grid-cols-1 gap-2 mt-2 p-3 rounded-lg ${
                    (data?.border_declar ?? 0) === 0 ? 'bg-gray-200' :
                    (data?.border_declar ?? 0) === 1 ? 'bg-red-200' :
                    (data?.border_declar ?? 0) === 2 ? 'bg-green-200' :
                    (data?.border_declar ?? 0) === 3 ? 'bg-yellow-200' :
                    'bg-white'
                }`}>
                    <p className="text-[#989ba5] text-[12px] col-span-4">{t("admin_border_declaration_status")}:</p>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(0);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 0
                                ? "bg-gray-500 text-white"
                                : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                        }`}
                    >
                        <p>{t("admin_no_declaration_needed")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(1);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 1
                                ? "bg-red-600 text-white"
                                : "bg-red-200 text-red-700 hover:bg-red-300"
                        }`}
                    >
                        <p>{t("admin_red")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(2);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 2
                                ? "bg-green-600 text-white"
                                : "bg-green-200 text-green-700 hover:bg-green-300"
                        }`}
                    >
                        <p>{t("admin_green")}</p>
                    </div>
                    <div
                        onClick={() => {
                            handleBorderDeclaration(3);
                        }}
                        className={`w-full h-10 rounded-lg flex items-center justify-center cursor-pointer font-bold transition-colors ${
                            data.border_declar === 3
                                ? "bg-yellow-500 text-white"
                                : "bg-yellow-200 text-yellow-700 hover:bg-yellow-300"
                        }`}
                    >
                        <p>{t("admin_yellow")}</p>
                    </div>
                </div>
            </div>
            <ContinueComponent
                showFlag={showContinue}
                actionFunction={handleDeletePackage}
                id={data.id}
                setShowContinue={setShowContinue}
            />
            {showPriceAudit && (
                <PriceAuditModal
                    pack={data}
                    onClose={() => setShowPriceAudit(false)}
                    onUpdated={() => setDifResponses && setDifResponses((p) => !p)}
                />
            )}
            {showIncident && (
                <IncidentModal
                    pack={data}
                    onClose={() => setShowIncident(false)}
                    onDone={() => setDifResponses && setDifResponses((p) => !p)}
                />
            )}
        </div>
    );
};
export default SentItem;
